import DgJsonView from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgJsonView.install = function (Vue) {
  Vue.component(DgJsonView.name, DgJsonView)
}
export default DgJsonView

export { DgJsonView }